
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.336.864a.9.9 0 10-1.272 1.272L12.128 4.2H1.7a.9.9 0 000 1.8h10.428l-2.064 2.064a.9.9 0 101.272 1.272l3.6-3.6a.9.9 0 000-1.272l-3.6-3.6zM5.936 9.936a.9.9 0 10-1.272-1.272l-3.6 3.6a.9.9 0 000 1.272l3.6 3.6a.9.9 0 001.272-1.272L3.872 13.8H14.3a.9.9 0 100-1.8H3.872l2.064-2.064z","fill":"#9499A6"}})])
          )
        }
      }
    